import { initializeApp, getApps, getApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  FacebookAuthProvider,
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyDp1ztbRhcFtRQnAYZSMjSSexsuOz2SnyE',
  authDomain: 'www.pttbrain.com',
  databaseURL: 'https://ptt-brain.firebaseio.com',
  projectId: 'ptt-brain',
  storageBucket: 'ptt-brain.firebasestorage.app',
  messagingSenderId: '659465876278',
  appId: '1:659465876278:web:5e921c30401d6f0c247997',
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
export const auth = getAuth(app);

export const providers = {
  google: new GoogleAuthProvider(),
  facebook: new FacebookAuthProvider(),
};

export default app;
